module.exports = __webpack_public_path__ + "img/elsa.3127b83a.png";